module.exports = __webpack_public_path__ + "media/images/respond-3c414d7dedf28e64a3c8d644e5fba53f.svg";